import MultiOrdersIndex from "@/views/multi-orders/Index";
import MultiOrdersDetail from "@/views/multi-orders/Detail";

export default [
  {
    path: "/multi-orders",
    name: "MultiOrders",
    component: MultiOrdersIndex,
  },

  {
    path: "/multi-orders/:id/show",
    name: "MultiOrdersShow",
    component: MultiOrdersDetail,
  },
];